module.exports = __webpack_public_path__ + "img/141.once_a_week.3be42f77.svg";